module.exports = __webpack_public_path__ + "static/media/patryk-bartczyk.2ad11b73.jpg";